import React from 'react';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const ThemesActions = ({ category }) => {
  const { allowRefresh, readStatus } = selectors.useThemesActions();
  const refresh = events.useRefreshThemes(category);

  return (
    <>
      {allowRefresh && (<RefreshActionMenu onClick={() => refresh({ page: 1 })} readStatus={readStatus} />)}
    </>
  );
};

export default ThemesActions;
